import React from 'react';

type QuickActionButtonProps = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
};

export function QuickActionButton({
  label,
  icon,
  onClick,
  variant = 'primary'
}: QuickActionButtonProps) {
  // Use semantic colors - primary for main brand actions
  const accentColor = variant === 'primary' ? '#5B8E87' : '#7B9EAE';

  return (
    <button
      onClick={onClick}
      className="bg-white rounded-2xl shadow-sm p-4 border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all active:scale-95"
      aria-label={label}
    >
      {/* Icon with subtle brand accent background */}
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-2 mx-auto"
        style={{ backgroundColor: `${accentColor}20` }}
      >
        <div className="text-gray-700">{icon}</div>
      </div>
      <div className="text-sm font-medium text-gray-900 text-center">{label}</div>
    </button>
  );
}
